/**
 * @file Bottom navigation bar — 6 tabs
 * Layout: Today | Jobs | Leads | Tasks | Customers | More
 * Timer and Camera moved to More menu.
 */

import { navigate } from '@core/router.js';

const tabs = [
  { id: 'today',     icon: '\uD83D\uDCCB', label: 'Today' },
  { id: 'jobs',      icon: '\uD83D\uDD27', label: 'Jobs' },
  { id: 'leads',     icon: '\uD83D\uDCDE', label: 'Leads' },
  { id: 'tasks',     icon: '\u2713',       label: 'Tasks' },
  { id: 'customers', icon: '\uD83D\uDC64', label: 'Customers' },
  { id: 'more',      icon: '\u2630',       label: 'More' },
];

/**
 * Render the bottom nav bar HTML and inject into #bottom-nav.
 */
export function renderBottomNav() {
  const nav = document.getElementById('bottom-nav');
  if (!nav) return;

  nav.innerHTML = tabs.map(tab => `
    <div class="bottom-nav-item" data-tab="${tab.id}">
      <span class="nav-icon">${tab.icon}</span>
      <span class="nav-label">${tab.label}</span>
    </div>
  `).join('');

  // Wire up tap handlers
  nav.querySelectorAll('.bottom-nav-item').forEach(item => {
    item.addEventListener('click', () => {
      const tabId = item.dataset.tab;
      navigate(tabId);
    });
  });
}

/**
 * Set a badge count on a tab.
 * @param {string} tabId
 * @param {number} count - 0 to hide badge
 */
export function setTabBadge(tabId, count) {
  const item = document.querySelector(`.bottom-nav-item[data-tab="${tabId}"]`);
  if (!item) return;

  let badge = item.querySelector('.nav-badge');
  if (count > 0) {
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'nav-badge';
      item.appendChild(badge);
    }
    badge.textContent = count > 99 ? '99+' : count;
  } else if (badge) {
    badge.remove();
  }
}
